export default {
  userReport: {
    date: "Ngày giờ báo cáo",
    userName: "Tài khoản thanh toán",
    proxyName: "cấp trên",
    userSubNum: "số cấp dưới trực tiếp",
    userAllSubNum: "số thành viên ",
    betCount: "số lần đặt cược",
    amount: "số tiền cược",
    validAmount: "Số tiền cược thực tế",
    rebateMoney: "Số tiền hoàn trả",
    userResult: "người dùng thắng thua(không bao gồm hoàn lại)",
    rebateAmount: "số tiền hoàn lại ",
    result: "thực tế thắng thua",
    platformCode: "nền tảng bạn thuộc về",
    userId: "tài khoản",
    proxyId: "Cấp trên",
    dateSearch: "thời gian",
    refreshData: "Làm mới dữ liệu",
    refresh: "Làm mới dữ liệu",
    datePlaceholder: "Vui lòng chọn ngày giờ",
    pumpingAmount: "Chiết khẩu tiền thưởng",
    activityPumping: "Chiết khấu ưu đãi",
    incomeAmount: "Tiền trả thưởng",
    returnAmountCount: "Tiền hoàn trả/Lần hoàn lại",
  },
  platformReport: {
    date: "trò chơi",
    regCount: "Đăng ký mới ",
    validUserCount: "Trung bình tổng số người dùng có hiệu quả",
    balance: "trung bình số dư nhà cái",
    member: "nạp rút",
    rechargeAmount: "Tổng số tiền nạp",
    withdrawAmount: "Số tiền rút",
    betCount: "số lần đặt cược",
    betCountTitle: "Lần cược/Chờ thanh toán/Hủy đơn",
    betRebateAmount: "Số tiền đặt cược / hoàn lại",
    betAmount: "số tiền cược / Số lần đặt cược",
    rebateAmount: "số tiền hoàn lại",
    validAmount: "Số tiền cược thực tế",
    pumpingAmount: "hao hồng tiền thưởng",
    activityPumping: "hoa hồng khuyến mãi",
    userGainLoss: "người dùng thắng thua (bao gồm tiền hoàn lại)",
    backAmount: "Số tiền hoàn trả",
    activityAmount: "chi phí khuyến mãi",
    platformGainLoss: "nhà cái lãi lỗ",
    platformCode: "nền tảng bạn thuộc về",
    dateSearch: "thời gian",
    day: "ngày",
    week: "tuần",
    month: "tháng",
    year: "năm",
    amount: "số tiền",
    amountType1: "nạp",
    amountType2: "rút",
    amountType3: "đặt cược",
    isWin: "Người dùng thắng thua",
    win: "thắng",
    lose: "thua",
    refreshData: "Làm mới dữ liệu",
    refresh: "Làm mới dữ liệu",
    datePlaceholder: "Vui lòng chọn ngày giờ",
    refreshMessage: "Tải lại dữ liệu cần thêm ít thời gian",
    userInfo: "Chi tiết người dùng",
    nickName: "Tên hiển thị",
    account: "tài khoản",
    createTime: "Thời gian đăng ký",
    registerIp: "IP đăng ký",
    ipAddress: "dân tộc",
    option: "thao tác",
    info: "Chi tiết tham gia",
    registerTitle: "Thêm đăng ký",
  },
  gameReport: {
    game: "trò chơi",
    betNum: "số lần đặt cược",
    userBetNum: "số người đặt cược",
    amount: "số tiền cược",
    validAmount: "Số tiền cược thực tế",
    rebateMoney: "tổng tiền hoàn lại",
    pumpingAmount: "hao hồng tiền thưởng",
    activityPumping: "hoa hồng khuyến mãi",
    userResult: "người dùng thắng thua(không bao gồm hoàn lại)",
    rebateAmount: "số tiền hoàn lại",
    result: "kết quả",
    platformCode: "nền tảng bạn thuộc về",
    date: "thời gian",
  },
  cashReport: {
    date: "ngày tháng",
    userName: "tài khoản",
    rechargeAmount: "Tổng số tiền nạp",
    rechargeNum: "số lần nạp",
    increaseAmount: "hậu đài lên tiền",
    withdrawAmount: "Số tiền rút",
    withdrawNum: "số lần rút",
    decreaseAmount: "hậu đài trừ tiền",
    betAmount: "Số tiền cược (bao gồm hoàn lại)",
    betAmountCount: "Tiền cược (gồm hoàn trả)",
    validAmount: "Số tiền cược thực tế",
    betGainLossAmount: "投注盈亏总金额",
    gainLossAmount: "用户盈亏总金额",
    activityAwardAmountTitle: "活动奖励/次数",
    balance: "trung bình số dư nhà cái",
    platformCode: "nền tảng bạn thuộc về",
    userId: "tài khoản",
    dateSearch: "thời gian",
    refreshData: "Làm mới dữ liệu",
    refresh: "Làm mới dữ liệu",
    datePlaceholder: "Vui lòng chọn ngày giờ",
    refreshMessage: "Tải lại dữ liệu cần ít thời gian, vui lòng chờ",
    returnAmountCount: "Tiền hoàn trả/Lần hoàn lại",
    incomeAmount: "Tiền trả thưởng",
    frozenAmountCount: "Tiền bị đình chỉ/Lần bị đình chỉ",
    thawAmountCount: "Tiền hết đình chỉ/Lần hết đình chỉ",
  },
  settlementReport: {
    platformCode: "nền tảng bạn thuộc về",
    platformGainLossTotal: "平台总盈亏",
    betAmountTotal: "Tổng cược (số tiền cược)",
    betValidAmountTotal: "Tổng cược thực tế (Tổng tiền cược thực tế)",
    pumpingRatio: "当前盈亏抽成比例",
    gamePumpingRatio: "当前流水抽成比例",
    pumpingAmountTotal: "抽成金额1",
    pumpingAmountTotalTip1: "非控盘平台类型抽水金额=平台总盈亏x盈亏抽成比例",
    pumpingAmountTotalTip2: "控盘平台类型抽水金额=平台盈亏（不包含大小3分钟）x盈亏抽成比例",
    gamePumpingAmountTotal: "抽成金额2（大小3分钟流水）",
    gamePumpingAmountTotalTip1: "游戏流水（大小3分钟）x当前流水抽成比例",
    dx3MinValidAmount: "游戏流水（大小3分钟）",
    dx3MinExcludePlatformGainLoss: "平台盈亏（不包含大小3分钟游戏）",
    pumpingTotalAmount: "抽成总金额",
    option: "thao tác",
    date: "thời gian",
    platformGainLoss: "Lãi và lỗ của nhà cái",
    betAmount: "Tổng cược (số tiền cược)",
    pumpingAmount: "Tỉ lệ chiết khấu",
    refresh: "Làm mới dữ liệu",
  },
  activityReport: {
    title1: "活动明细报表",
    title2: "活动汇总/日",
    title3: "活动汇总/人",
    createTime: "领取时间",
    account: "账号",
    awardAmount: "领取奖励",
    activityId: "参与活动类型",
    activityType: "活动类型",
    awardAmountSum: "日领取奖励"
  }

}
